import { latestUpdates } from '@/mocks/homeData';

export default function LatestUpdatesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新更新
          </h2>
          <p className="text-foreground-500 text-sm">每日更新，精彩不断</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-1">
          <div className="divide-y divide-background-200/70">
            {latestUpdates.map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer rounded-xl"
              >
                <div className="flex items-center gap-4 min-w-0">
                  <span className="w-2 h-2 rounded-full bg-accent-500 flex-shrink-0"></span>
                  <div className="min-w-0">
                    <h4 className="text-sm font-medium text-foreground-900 truncate">
                      {item.title}
                    </h4>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs text-primary-600 font-medium">{item.category}</span>
                      <span className="text-xs text-foreground-400">·</span>
                      <span className="text-xs text-foreground-500">{item.episode}</span>
                    </div>
                  </div>
                </div>
                <span className="text-xs text-foreground-400 flex-shrink-0 ml-4">{item.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}